import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { StepSetupInterviewComponent } from '../step-setup-interview/step-setup-interview.component';
import { StepAddContextComponent } from '../step-add-context/step-add-context.component';
import { StepChooseOptionsComponent } from '../step-choose-options/step-choose-options.component';
import { StepDeviceCheckComponent } from '../step-device-check/step-device-check.component';
import { StepInstructionsComponent } from '../step-instructions/step-instructions.component';
import { StepInterviewComponent } from '../step-interview/step-interview.component';
import { AiInterviewSessionService } from '@edtech-ui/core/services/ai-interview-session-service/ai-interview-session.service';

@Component({
  selector: 'app-interview-setup-wizard',
  standalone: true,
  imports: [CommonModule, StepSetupInterviewComponent,
    StepAddContextComponent,
    StepChooseOptionsComponent,
    StepDeviceCheckComponent,
    StepInstructionsComponent,
    StepInterviewComponent,],
  templateUrl: './interview-setup-wizard.component.html',
  styleUrl: './interview-setup-wizard.component.scss'
})
export class InterviewSetupWizardComponent {
  constructor(private aiSessionService: AiInterviewSessionService, private router: Router) { }
  isNavigating = false;

  steps = [
    'Setup Interview',
    'Add Context',
    'Choose Options',
    'Device Check',
    'Instructions',
    'Interview',
  ];

  headerTitles = [
    'Set Up Your Mock Interview',
    'Personalize Your Interview',
    'Choose Duration & Interviewer',
    'Check Your Setup',
    'Before You Begin',
    'Your Interview Session',
  ];

  headerIcons = [
    'bi bi-bullseye',
    'bi bi-chat-dots',
    'bi bi-sliders2',
    'bi bi-laptop',
    'bi bi-lightbulb',
    'bi bi-camera-video',
  ];

  currentStep = 1;


  ngOnInit() {
    const savedStep = localStorage.getItem('currentStep');
    const loggedInUser = localStorage.getItem('auth_token'); // or however you store session

    // If no logged-in user, reset the wizard
    if (!loggedInUser) {
      localStorage.removeItem('currentStep');
      this.currentStep = 1;
      this.aiSessionService.reset(); // clear BehaviorSubject + localStorage

      return;
    }

    if (savedStep) {
      const step = +savedStep;
      this.currentStep = step > this.steps.length ? 1 : step;
    } else {
      this.currentStep = 1;
    }
  }

  get progressPercent(): number {
    return Math.round((this.currentStep / this.steps.length) * 100);
  }

  nextStep() {
    if (this.currentStep < this.steps.length) {
      this.currentStep++;
      localStorage.setItem('currentStep', this.currentStep.toString());
    } else {
      localStorage.removeItem('currentStep');
    }
  }


  goBackToDashboard() {
    this.router.navigate(['/student-dashboard/ai-interview-dashboard']);
  }

  prevStep() {
    if (this.currentStep > 1) {
      this.currentStep--;
      localStorage.setItem('currentStep', this.currentStep.toString());
    }
  }

  handleContinue() {
    this.nextStep();
  }

  handleSkip() {
    this.nextStep();
  }
}

